const StaffComponent = () => import('@/views/staff/StaffView')

export default [
    {
        path:'/StaffIndex',
        name:'StaffRouter',
        component:StaffComponent
    }
]